module.exports = __webpack_public_path__ + "static/img/notfound.e604d06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notfound.png
// module id = FpLo
// module chunks = 1